import styled from 'styled-components'
import Sizes from './sizes'

export default styled(Sizes.xxxl).attrs({ as: 'h1' })`
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 2rem;
`
